import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["user.documents"],
  documents => documents
);
